export default "__VITE_ASSET__CGh67zrd__"